module.exports = __webpack_public_path__ + "static/images/armani.058d20c91ccfa0a23f5d0024fb4958c7.jpg";